// src/lib/petNotes.js
import { Storage } from "aws-amplify";

const PET_NOTES_LAMBDA_URL =
  "https://mycobvpzx7pwy35eru5utxdatu0ioamb.lambda-url.us-east-1.on.aws/";

// ✅ List notes
export async function listNotes(tagId) {
  const res = await fetch(PET_NOTES_LAMBDA_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      action: "listNotes",   // 🔥 only listNotes here
      tagId: tagId.toUpperCase(),
    }),
  });

  if (!res.ok) throw new Error("Failed to list notes");
  const data = await res.json();
  return data.items || [];
}

// ✅ Delete a single note by sk
export async function deletePetNote(tagId, sk) {
  const res = await fetch(PET_NOTES_LAMBDA_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      action: "deleteNote",
      tagId: tagId.toUpperCase(),
      sk, // e.g. "NOTE#2025-11-21T13:22:00Z"
    }),
  });

  if (!res.ok) {
    throw new Error(`Failed to delete note: ${res.status}`);
  }

  return true;
}

// Add a note (with optional File object for photo)
export async function addPetNote({ tagId, content, category, mood, photoFile }) {
  if (!tagId) throw new Error("Missing tagId");

  let photoKey = null;

  if (photoFile) {
    const ext = photoFile.name.split(".").pop() || "jpg";
    const ts = Date.now();
    const upperTag = tagId.toUpperCase();
    photoKey = `public/pets/${upperTag}/notes/note-${ts}.${ext}`;

    await Storage.put(photoKey, photoFile, {
      contentType: photoFile.type || "image/jpeg",
    });
  }

  const res = await fetch(PET_NOTES_LAMBDA_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      action: "addNote",
      tagId,
      content,
      category,
      mood,
      photo: photoKey,
    }),
  });

  if (!res.ok) throw new Error("Failed to add note");
  const data = await res.json();
  return data.note;
}

// Helper to turn ISO -> friendly date/time
export function formatNoteTimestamp(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;

  const month = d.getMonth() + 1;
  const day = d.getDate();
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = d.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  if (hours === 0) hours = 12;

  const mm = String(minutes).padStart(2, "0");
  return `${month}/${day}/${year} ${hours}:${mm}${ampm}`;
}
